/**
 * The project the portal talks to, compiled in by `vite.config.ts` from the
 * two browser-safe settings. Empty on a build that was given none, which the
 * page says plainly rather than failing at the first request.
 */

declare const __PORTAL_SETTINGS__: {
  readonly url: string;
  readonly publishableKey: string;
};

export const SETTINGS = __PORTAL_SETTINGS__;

export function configured(): boolean {
  return SETTINGS.url !== '' && SETTINGS.publishableKey !== '';
}
